import React, { useState, useEffect } from 'react';
import './Header.css';
import { useNavigate, NavLink } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, firestore } from './firebase';
import { FaBars } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import { doc, getDoc } from 'firebase/firestore';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [initials, setInitials] = useState('');
    const navigate = useNavigate();

    const fetchInitials = async () => {
        const loginName = localStorage.getItem('workerLoginName');
        if (!loginName) return;

        const userRef = doc(firestore, 'users', loginName);
        const snap = await getDoc(userRef);
        let fullName = loginName;
        if (snap.exists() && snap.data().Name) {
            fullName = snap.data().Name;
        }

        const parts = fullName.trim().split(/\s+/).filter(Boolean);
        let init = '';
        if (parts.length === 1) {
            init = parts[0][0];
        } else if (parts.length > 1) {
            init = parts[0][0] + parts[parts.length - 1][0];
        }
        setInitials(init.toUpperCase());
    };

    useEffect(() => {
        fetchInitials();
        const handleLogin = () => fetchInitials();
        window.addEventListener('workerLogin', handleLogin);
        return () => {
            window.removeEventListener('workerLogin', handleLogin);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('workerLoginName');
        setInitials('');
        signOut(auth).then(() => {
            navigate("/");
            console.log("Signed out successfully");
        }).catch((error) => {
            console.error("Error signing out:", error);
        });
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleMenuLinkClick = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="header fade-in">
                <FaBars className="burger-menu" onClick={toggleMenu} />
                <img className="logo" src="Logo.png" alt="Logo" />
                <ul className="desktop-menu">
                    <li>
                        <NavLink to="/worker-dashboard" className={({ isActive }) => (isActive ? 'active' : undefined)}>Wochenmenü</NavLink>
                    </li>
                    <li>
                        <NavLink to="/menuwahl" className={({ isActive }) => (isActive ? 'active' : undefined)}>Menüwahl</NavLink>
                    </li>
                    <li>
                        <NavLink to="/inwil" className={({ isActive }) => (isActive ? 'active' : undefined)}>Reservierung Inwil</NavLink>
                    </li>
                    <li>
                        <NavLink to="/monatsauszug" className={({ isActive }) => (isActive ? 'active' : undefined)}>Monatsauszug</NavLink>
                    </li>
                </ul>
                <img className="logout" onClick={handleLogout} src="logout.png" alt="Logout" />
            </div>

            <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                <div className="side-menu-header">
                    <AiOutlineClose className="close-menu" onClick={toggleMenu} />
                    {initials && <div className="user-initials">{initials}</div>}
                </div>
                <ul>
                    <li className="side-menu-title">Menü</li>
                    <li>
                        <NavLink
                            to="/worker-dashboard"
                            onClick={handleMenuLinkClick}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                        >
                            Wochenmenü
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/menuwahl"
                            onClick={handleMenuLinkClick}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                        >
                            Menüwahl
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/inwil"
                            onClick={handleMenuLinkClick}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                        >
                            Reservierung Inwil
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/monatsauszug"
                            onClick={handleMenuLinkClick}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                        >
                            Monatsauszug
                        </NavLink>
                    </li>
                </ul>
            </div>

            {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
        </>
    );
};

export default Header;